import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2'; // Importe Swal
import {
  MainContainer, BackgroundPattern, ContentWrapper,
  HeaderSection,
  Title, Subtitle,
  SearchContainer,
  SearchInput,
  SearchButton,
  StyledTable,
  AposentarButton,
  AposentadoButton,
  PaginationContainer,
  PageButton,
} from './styles';
import { projectService } from '../../../services/projectService';

const ProjectTokensRetirementList = ({ project_id }) => {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const searchInputRef = useRef(null);

  useEffect(() => {
    fetchData();
  }, [currentPage, itemsPerPage]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem('Authorization');
      const data = await projectService.getProjectTokens(token);
      setItems(data);
    } catch (error) {
      console.error('❌ Erro ao buscar tokens de projeto:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const aposentarItem = async (item) => {
    Swal.fire({
      title: 'Você tem certeza?',
      text: 'Deseja realmente aposentar este token?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim, aposentar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        aposentarTokenConfirmado(item);
      }
    });
  };

  const aposentarTokenConfirmado = async (item) => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem('Authorization');

      await projectService.retireProjectToken(item.id, token);

      const updatedItems = items.map((oldItem) =>
        oldItem.id === item.id ? { ...oldItem, status: false } : oldItem
      );
      setItems(updatedItems);

    } catch (error) {
      console.error('Error aposentando item:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      setIsLoading(true);
      const token = sessionStorage.getItem('Authorization');

      // Chama o novo método centralizado no service
      const responseData = await projectService.getProjectTokensBySearch(searchTerm, token);

      setItems(responseData);
    } catch (error) {
      console.error('Error searching data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchOnEnter = (event) => {
    if (event.key === 'Enter') {
      handleSearch();
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(items.length / itemsPerPage); i++) {
    pages.push(i);
  }

  return (
    <MainContainer>
      <BackgroundPattern />
      <ContentWrapper>
        <HeaderSection>
          <Title>Tokens Aposentadoria</Title>
          <Subtitle>Gerencie e visualize os tokens ativos e aposentados</Subtitle>
        </HeaderSection>

        <SearchContainer>
          <SearchInput
            type="text"
            placeholder="Pesquisar Tokens..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={handleSearchOnEnter}
            ref={searchInputRef}
          />
          <SearchButton type="button" onClick={handleSearch}>
            Pesquisar
          </SearchButton>
        </SearchContainer>

        <StyledTable>
          <thead>
            <tr>
              <th>Tokens</th>
              <th>Data Hora</th>
              <th>Quantidade</th>
              <th>Status</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan="5">Carregando...</td>
              </tr>
            ) : (
              items
                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                .map((item, index) => (
                  <tr key={item.id}>
                    <td>{item.token}</td>
                    <td>{item.date_time_cad}</td>
                    <td>{item.quantidade}</td>
                    <td>{item.status ? "Ativo" : "Inativo"}</td>
                    <td>
                      {item.status ? (
                        <AposentarButton onClick={() => aposentarItem(item)}>
                          Aposentar
                        </AposentarButton>
                      ) : (
                        <AposentadoButton disabled>Aposentado</AposentadoButton>
                      )}
                    </td>
                  </tr>
                ))
            )}
          </tbody>
        </StyledTable>

        <PaginationContainer>
          <span>Página:</span>
          {pages.map((page) => (
            <PageButton
              key={page}
              onClick={() => handlePageChange(page)}
              disabled={page === currentPage}
            >
              {page}
            </PageButton>
          ))}
        </PaginationContainer>
      </ContentWrapper>
    </MainContainer>
  );

};

export default ProjectTokensRetirementList;
